import { TradingBlockOrderStatusEnum } from '../dtos/orders.dtos';

export namespace OrderConstant {
  export const ESTIMATED_SERVICE_FEE = 10;
  export const UNCANCELLED_STATUS_LIST = [TradingBlockOrderStatusEnum.New, TradingBlockOrderStatusEnum.Initiated];
  export const DEFAULT_TAKE_QUERY_PARAM = 50;
  export const DEFAULT_SKIP_QUERY_PARAM = 0;
}
